import { render } from "./NewPasswordForm.vue?vue&type=template&id=40cdc099&scoped=true"
import script from "./NewPasswordForm.vue?vue&type=script&lang=js"
export * from "./NewPasswordForm.vue?vue&type=script&lang=js"

import "./NewPasswordForm.vue?vue&type=style&index=0&id=40cdc099&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cdc099"]])

export default __exports__